// Meta de peso. Mesma régua, com a banda de referência apontando para o peso
// atual — e a diferença escrita em ouro, como o desenho pede.

import React, { useEffect, useState } from "react";

import RulerPicker from "../components/RulerPicker.jsx";
import { CardRegua } from "../widgets/Widgets.jsx";

const StepTargetWeight = ({ setCanProceed, setStepData, answers }) => {
  const pesoAtual = answers?.CURRENT_WEIGHT
    ? parseFloat(String(answers.CURRENT_WEIGHT).replace(",", "."))
    : 75.0;

  const [valor, setValor] = useState(
    pesoAtual > 0 ? Math.max(40, Math.min(150, pesoAtual)) : 70.0
  );

  useEffect(() => {
    setCanProceed(true);
    setStepData({ TARGET_WEIGHT: valor.toFixed(1).replace(".", ",") });
  }, [valor, setCanProceed, setStepData]);

  const delta = +(valor - pesoAtual).toFixed(1);
  const referencia =
    delta === 0
      ? "Manter o peso atual"
      : `Meta: ${delta < 0 ? "perder" : "ganhar"} ${Math.abs(delta)
        .toFixed(1)
        .replace(".", ",")} kg`;

  return (
    <CardRegua
      valor={valor.toFixed(1).replace(".", ",")}
      unidade="kg"
      referencia={referencia}
    >
      <RulerPicker
        axis="x"
        min={40}
        max={150}
        step={0.2}
        decimals={1}
        majorEvery={1}
        initialValue={valor}
        refValue={pesoAtual}
        showBand
        onChange={setValor}
      />
    </CardRegua>
  );
};

export default StepTargetWeight;
